import ApiService from './ApiService';

export async function fetchRoles (data) {
    return ApiService.fetchData({
        url: '/rbac/roles/all',
        method: 'post',
        data
    })
}

export async function fetchRolesList (params) {
    return ApiService.fetchData({
        url: '/rbac/roles/list',
        method: 'get',
        params
    })
}

export async function fetchaRolesPagesCta ( params ){
    return ApiService.fetchData({
        url: '/rbac/roles/pages/cta',
        method: 'get',
        params
    })
}
export async function fetchaRolesPagesAndCtaByRoleId ( params ){
    return ApiService.fetchData({
        url: '/rbac/roles/pages/cta/by',
        method: 'get',
        params
    })
}

export async function createRolesPagesAndCtaByRoleId ( data ){
    return ApiService.fetchData({
        url: '/rbac/roles/pages/cta/create',
        method: 'post',
        data
    })
}

export async function fetchRolesNavByRoleId ( params ){
    return ApiService.fetchData({
        url: '/rbac/roles/nav/by',
        method: 'get',
        params
    })
}

export async function createRole ( data ){
    return ApiService.fetchData({
        url: '/rbac/role/create',
        method: 'post',
        data
    })
}
export async function fetchCta(params) {
    return ApiService.fetchData({
        url: `/customer/cta`,
        method: 'get',
        params
    })
}
export async function fetchCtaByRoleId(params) {
    return ApiService.fetchData({
        url: `/rbac/cta`,
        method: 'get',
        params
    })
}
export async function fetchPagesByRoleId(params) {
    return ApiService.fetchData({
        url: `/rbac/roles/pages`,
        method: 'get',
        params
    })
}



